import * as angular from 'angular';

export const Module = angular.module('reverse-ajax', []);



// WEBPACK FOOTER //
// ./src/modules/reverse-ajax/module.js